// extracted by mini-css-extract-plugin
var _1 = "nilV9";
var _2 = "dN358";
var _3 = "XLh8s";
export { _1 as "banner", _2 as "frame", _3 as "isError" }
